<pages-container [title]="'certificate.new'" [icon]="'workspace_premium'">
  <div back-button>
    <button class="back-button" mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div buttons>
    <button mat-raised-button type="button" class="mat-white-bg" (click)="downloadExamplePdf()">
      {{'certificate.download_example' | translate}}
    </button>
    <button mat-raised-button class="mat-white-bg" [disabled]="!name?.trim()" (click)="save()">
      {{ 'certificate.save' | translate }}
    </button>
    @if (id) {
      <button mat-raised-button class="mat-white-bg" (click)="deleteTemplate()">
        {{ 'main.delete' | translate }}
      </button>
    }
  </div>
  <div main-content class="certificate-detail">
    <mat-form-field class="width-100">
      <mat-label>{{ 'certificate.name' | translate }}</mat-label>
      <input matInput name="name" [(ngModel)]="name" required>
    </mat-form-field>
    <div class="certificate-editor">
      <div class="certificate-editor">
        <div class="certificate-toolbar">
          <mat-checkbox [ngModel]="isPortrait" (ngModelChange)="setOrientation($event)">{{ 'certificate.portrait_orientation' | translate }}</mat-checkbox>
          <div>
            <button mat-raised-button type="button" (click)="backgroundInput.click()">
              {{ 'certificate.choose_background' | translate }}
            </button>
            <input #backgroundInput type="file" accept="image/png,image/jpeg" hidden
                   (change)="onBackgroundSelected($event)"/>
            @if (hasBackground) {
              <button mat-raised-button type="button" (click)="removeBackground()">
                {{ 'certificate.remove_background' | translate }}
              </button>
            }
          </div>
          <div>
            @for (field of dynamicFields; track field.field) {
              <button mat-raised-button
                type="button"
                (click)="addDynamicField(field)">
                + {{ field.label | translate }}
              </button>
            }
          </div>
          <div>
            <button mat-raised-button type="button" (click)="imageInput.click()">
              + {{ 'certificate.image' | translate }}
            </button>

            <input
              #imageInput
              type="file"
              accept="image/png,image/jpeg"
              hidden
              (change)="onImageSelected($event)"
            />
            <button mat-raised-button type="button" (click)="addStaticText()">
              + {{ 'certificate.text' | translate }}
            </button>
            <button mat-raised-button type="button" (click)="addLine()">
              + {{ 'certificate.line' | translate }}
            </button>
          </div>

        </div>

        <div
          #designerContainer
          class="designer-container"
        ></div>
      </div>
    </div>
  </div>
</pages-container>
